import React from 'react';
import styled from 'styled-components';
import { colors, radii, fonts } from '../designSystem';

/**
 * « Labellisé Bonus Répar » : l'étiquette d'un atelier qui applique le Bonus
 * Répar. Pleine et sombre, comme une médaille : elle doit se lire d'un coup
 * d'œil sur la photo d'une carte, sous le nom d'une fiche ou dans le tunnel,
 * là où une phrase en petits caractères passait inaperçue (retour de Clément
 * du 14/10).
 */
const Pastille = styled.span`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  padding: ${(p) => (p.$grand ? '7px 16px 7px 10px' : '5px 12px 5px 8px')};
  border-radius: ${radii.pill};
  background: ${colors.bleuFonce};
  color: ${colors.vert};
  font-family: ${fonts.body};
  font-weight: 700;
  font-size: ${(p) => (p.$grand ? '0.9rem' : '0.78rem')};
  line-height: 1.2;
  white-space: nowrap;

  svg {
    width: ${(p) => (p.$grand ? '18px' : '15px')};
    height: ${(p) => (p.$grand ? '18px' : '15px')};
    flex-shrink: 0;
  }
`;

export default function BadgeBonusRepar({
  children = 'Labellisé Bonus Répar',
  grand = false,
  ...rest
}) {
  return (
    <Pastille data-testid="badge-bonus-repar" $grand={grand} {...rest}>
      <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <circle cx="8" cy="8" r="8" fill={colors.vert} />
        <path
          d="M4.6 8.3l2.2 2.2 4.6-4.8"
          fill="none"
          stroke={colors.bleuFonce}
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {children}
    </Pastille>
  );
}
